module.exports = __webpack_public_path__ + "img/assistantPage.cfb07764.png";